import '@/scss/style.scss';
import '@/scss/critical.scss';
//import '@/scss/gutenberg.scss';
import modular from 'stereomodularjs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';
import './utils/events';

const app = new modular({
    modules: modules
});

let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
window.isMobile = isMobile;

if (window.isMobile) {
    document.documentElement.classList.add('is-mobile');
}

let loadTimeout = setTimeout(() => {
    if (!window.onloadExecuted) {
        window.onloadExecuted = true; // Ensure the flag is set
        execute_on_load();
    }
}, 1000);

window.onload = () => {
    if (!window.onloadExecuted) {
        clearTimeout(loadTimeout); // Clear the timeout
        window.onloadExecuted = true; // Ensure the flag is set
        execute_on_load();
    }
};

function execute_on_load() {
    init(); // Your initialization logic
}

function init() {
    window.transitionDelay = 600;

    globals();

    app.init(app);

    (function() {
        const ua = navigator.userAgent;

        // Uncomment line to test old safari
        //document.documentElement.clafssList.add("safari-older");

        // Vérifie si le navigateur est Safari (mais pas Chrome ou autre basé sur WebKit)
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

        if (isSafari) {
            // Extrait la version de Safari
            const match = ua.match(/Version\/(\d+)\.(\d+)/);
            if (match) {
                const majorVersion = parseInt(match[1], 10);
                const minorVersion = parseInt(match[2], 10);

                // Vérifie si la version est inférieure à 14.1
                if (majorVersion < 14 || (majorVersion === 14 && minorVersion < 1)) {
                    console.log("Safari < 14.1 détecté !");
                    // Ajoute une classe au body ou applique un style spécifique
                    document.documentElement.classList.add("safari-older");
                }
            }
        }
    })();

    const loaderAnimation = new Promise(resolve => {
        const duration = 'development' ? 0 : 600
        let delay = new Date()
        delay = (delay - window.timestamp)
        delay = Math.max(0, duration - delay)
        setTimeout(() => {
            resolve()
        }, delay)
    })

    setTimeout(() => {
        let preventChilds = document.querySelectorAll('.js-prevent-childs a');
        preventChilds.forEach(el => {
            el.classList.add('js-prevent');
        });

        // Detect links with the class .cmplz-link.cookie-statement and add data-load="false"
        let cookieStatementLinks = document.querySelectorAll('.cmplz-link.cookie-statement');
        cookieStatementLinks.forEach(link => {
            link.setAttribute('data-load', 'false');
        });

    }, 10);

    Promise.all([loaderAnimation]).then(() => {
        firtsLoadClasses();
    })
}

function firtsLoadClasses() {
    html.classList.add('is-first-loaded');
    html.classList.add('is-loaded');
    html.classList.add('dom-is-loaded');
    html.classList.remove('is-loading');

    setTimeout(() => {
        html.classList.add('anims-ready');
    }, window.transitionDelay);
}
